import React from 'react';
import KickImage from 'Reuseables/KickImage';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Select from 'react-select';
import ReactLoading from 'react-loading';
import {
  Container,
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Input,
  Alert
} from 'reactstrap';

import { getRaffleProducts, submitRaffle } from '../../../actions/raffleActions';
import { doSentLinkVerificationEmail } from '../../../actions/authAction';
// import { SquareCheckbox } from '../../../components/Forms/RadioButton';

import { convertToRupiah } from '../../../utils';
import RaffleSizeDropDown from './RaffleSizeDropDown';
import RaffleDropDown from './RaffleDropDown';
import RaffleLoginBox from './RaffleLoginBox';
import { ButtonDone } from './styled';

const Loading = styled.div`
  height: 180px;
  .loading__wrapper{
    width: 200px;
    flex: 1;
    display: flex;
    padding: 1rem 2.5rem;
    justify-content: center;
    align-items: center;
  }
`;

const ValidationMsg = styled.div`
  color: #dc3545;
  margin-bottom: 0px;
  margin-top: .5rem;
  display: block;
  ${'' /* font-style: normal; */}
  margin-left: .75rem;
  ${'' /* text-align: left; */}
  ${'' /* font-weight: normal; */}
  font-size: 10px;
  ${'' /* font-family: 'Nunito Light'; */}
`;

const AlertError = styled.div`
  display: flex;
  align-items: center;
  min-height: 200px;
  padding: 1rem 2.5rem;
  >p{
    margin: 0;
    line-height: 1.5;
    padding: 2rem 0rem;
    text-align: center;
  }
`;

const AlertErrorFetch = ({ children }) => (
  <AlertError>
    { children }
  </AlertError>
)

const AlertErrorUnverifiedMsg = ({onClick, disabled}) => (
  <div className="Unverified">
    <p>
      Please check your e-mail to verify your account. Simply click the link given on the email to complete this process.
    </p>
    <Row className="btn-verif">
        <Col>
          <Button className="btn-green bold btn-send-verify"
          onClick={onClick}
          disabled={disabled}>
          Send Verification Email
          </Button>
        </Col>
    </Row>
  <p className="unverified-text">Please refresh this page once you are verified</p>
  </div>
)

const AlertErrorAlreadySubmitMsg = () => (
  <p>
    Your entry has been recorded. You cannot enter another submission.<br/>
    Thank you for participating.
  </p>
)

const AlertErrorRaffleClosedMsg = () => (
  <p>
    This event has been concluded. We’ll be announcing another events in the coming future.<br/>
    Thank you for participating.
  </p>
)

class RaffleSelectSneakers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedSneakers: {value:"",label:'Select sneakers', sizes: [], retail_price: ""},
      selectedSize: {value:"",label:'Select sizes'},
      listProducts: [
        {value:"",label:'Select sneakers', sizes: [], retail_price: ""}
      ],
      listSizes: [
        {value:"",label:'Select sizes'}
      ],
      isAgreed: false,
      isLoading: false,
      _errors: null,
      //isWebApp : document.referrer.match(/telegram|whatsapp|facebook|instagram|twitter/i)
      isWebApp : (/telegram|whatsapp|facebook|instagram|twitter/i).test(document.referrer)
    }
    this.handleTickRaffle = this.handleTickRaffle.bind(this);
    this._onSentEmail = this._onSentEmail.bind(this);
  }

  async doGetRaffleProducts() {
    const data = await this.props.getRaffleProducts();
  }

  componentDidMount() {
    this.doGetRaffleProducts();
  }

  componentWillReceiveProps(nextProps) {
    const { dataRaffle } = nextProps;
    // .log('dataRaffle ', dataRaffle);
    if (!dataRaffle.isFetch && this.props.dataRaffle.isFetch !== dataRaffle.isFetch) {
      if (dataRaffle.status_code === 200) {
        const def = {value:"",label:'Select sneakers'}
        let products = [];
        dataRaffle.data.forEach(item => {
          products.push({
            value: item.id,
            label: `${item.display_name} | IDR. ${convertToRupiah(parseInt(item.pivot.retail_price, 10))}`,
            display_name: item.display_name,
            retailPrice: `IDR. ${convertToRupiah(parseInt(item.pivot.retail_price, 10))}`,
            sizes: item.sizes,
            urlImage: item.product_variant_images[0].signed_url || item.product_variant_images[0].URL,
          });
        })
        this.setState({ listProducts: [def, ...products] })
      } else if (dataRaffle.error) {
        this.setState({
          _errors: {
            ...dataRaffle.error,
            error: dataRaffle.error.type,
            isErrorFetch: true
          }
        })
      }
    }
  }

  handleChange = (selectedSneakers) => {
    let defSize = { value: "", label: 'Select Size' };
    if (selectedSneakers.value !== "") {
      let sizes = [];
      selectedSneakers.sizes.forEach(item => {
        sizes.push({
          value: item.id,
          label: `US ${item.US}`,
        })
      })
      this.setState({ selectedSneakers, listSizes: [defSize, ...sizes], selectedSize: {value:"",label:'Select sizes'} });
    } else {
      this.setState({
        selectedSneakers: { value: "", label: "Select Sneakers" }
      })
    }
  }

  handleChangeSizes = (selectedSize) => {
    this.setState({ selectedSize })
  }

  handleTickRaffle() {
    this.setState({ isAgreed: !this.state.isAgreed })
  }

  formValidation() {
    let { selectedSneakers, selectedSize, isAgreed } = this.state;
    let errors = {};

    if (selectedSneakers.value === "")
      errors['selectedSneakers'] = ['Please select the desired sneakers.'];
    if (selectedSize.value === "")
      errors['selectedSize'] = ['Please select your sneakers size.'];
    if (!isAgreed)
      errors['isAgreed'] = ['Please check the tick box before proceeding.'];
    if (Object.keys(errors).length) {
      this.setState({
        _errors: errors
      })
    }
    return errors;
  }

  errorChecker(params) {
    if (this.state._errors !== null) {
      const isErrorExist = Object.keys(this.state._errors).filter(err => err === params).length > 0;
      if (isErrorExist) {
        return (
          <ValidationMsg className="validation-msg">
            { this.state._errors[`${params}`][0] }
          </ValidationMsg>
        )
      }
    }
  }

  doSubmitSubmitRaffle = async () => {
    const { selectedSneakers, selectedSize } = this.state;
    const resultValidation = await this.formValidation();

    if (Object.keys(resultValidation).length === 0) {
      await this.setState({ _errors: null, isLoading: true })
      try {
        const raffleProduct = {
          raffle_id: 1,
          variant_id: selectedSneakers.value,
          size_id: selectedSize.value
        }

        const responses = await this.props.submitRaffle(raffleProduct);
        const { status_code } = responses.value
        if (status_code === 200) {
          await this.setState({ _errors: null, isLoading: false })
          this.props.history.push({
            pathname: `/promo/reactxdisruptor/submit-sneakers`,
            state: { urlImage: this.state.selectedSneakers.urlImage }
          })
        } else {
          await this.setState({ _errors: { error: 'Submit error' }, isLoading: false })
        }

      } catch (error) {
        await this.setState({ _errors: { error: 'Submit error' }, isLoading: false })
      }
    }
  }

  _onSentEmail(){
    this.props.submit();
    setTimeout(()=>{
        if(this.props.isOpen===true)
            this.props.onToggle();
        this.props.onSuccess();
    },300)
  }

  renderContent() {
    const { dataAuth, dataRaffle } = this.props;
    const { selectedSneakers, listProducts, listSizes, selectedSize } = this.state;

    if (this.state._errors !== null && this.state._errors.error !== undefined && this.state._errors.isErrorFetch === true) {
      return (
        <AlertErrorFetch>
          {
            this.state._errors.error === 'ALREADY_SUBMIT_ERR'?
            <AlertErrorAlreadySubmitMsg/>
            :(
              this.state._errors.error === 'FORBIDDEN_ERR'?
              <AlertErrorUnverifiedMsg
              onClick={this._onSentEmail}
              disabled={dataAuth.userSentLinkEmailVerify.isSubmit}
              />
              :
              <AlertErrorRaffleClosedMsg/>
            )
          }
        </AlertErrorFetch>
      )
    } else {
      return(
        <div className="raffle-wrappercontent">
          <div className="raffle-texttop">
            <p className="raffle-texttop__user">{ dataAuth.userdata.email }</p>
            <p>
              Complete the form below to
              get a chance buying the selected
              sneakers at RETAIL
            </p>
          </div>
          <div className="raffle-dropdown">
            {/* <p>Select Sneakers</p> */}
            <Select
              name={"Select sneakers"}
              value={selectedSneakers}
              onChange={this.handleChange}
              options={listProducts}
              className="raffle-picker raffle-picker__sneakers"
              optionComponent={RaffleDropDown}
              searchable={false}
            />
            {
              this.errorChecker('selectedSneakers')
            }
          </div>
          <div className="raffle-dropdown">
            {/* <p>Select Size</p> */}
            <Select
              searchable={false}
              value={selectedSize}
              onChange={this.handleChangeSizes}
              options={listSizes}
              className="raffle-picker raffle-picker__size"
              optionComponent={RaffleSizeDropDown}
            />
            {
              this.errorChecker('selectedSize')
            }
          </div>
          <div className="raffle-textbottom">
            <FormGroup check>
              <Label check>
                <Input onChange={this.handleTickRaffle} checked={this.state.isAgreed} type="checkbox" />{' '}
                <p>I have read and agreed to the <span>terms and conditions </span>
                  of the following event
                </p>
              </Label>
            </FormGroup>
            {
              this.errorChecker('isAgreed')
            }
          </div>
          <ButtonDone
            onClick={this.doSubmitSubmitRaffle}
            className="raffle-button white-button">
            SUBMIT 
          </ButtonDone>
        </div>
      )
    }
  }

  render() {

    const { dataAuth, dataRaffle } = this.props;
    const { selectedSneakers, listProducts, listSizes, selectedSize, isWebApp } = this.state;
    if (!dataAuth.isLogged) {
      return (
        <RaffleLoginBox
          onBtnLoginClick={e=> this.props.history.replace({ pathname: '/login', search: "?next=/promo/reactxdisruptor" })}
          headerText="GET REACT NIKE ELEMENT 87 ANTRACITE AND FILA DISRUPTOR II FOR RETAIL PRICE"
          footerText="Refresh this page if you have successfully registered / logged in on the website."
        />
      )
    }
    return (
      <div className="raffle-content">
      {
        this.props.dataRaffle.isFetch ?
        <Loading className="raffle-wrappercontent loading">
          <div className="loading__wrapper">
            <ReactLoading type={"spokes"} color={"#159953"} height={45} width={45}/>
          </div>
        </Loading>
        :
        this.renderContent()
      }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  dataAuth : state.dataAuth,
  dataRaffle: state.raffleReducer.raffleProducts,
  isWebApp: state.loginReferralReducer.loginReferral.isWebApp
})

const mapDispatchToProps = dispatch => ({
  getRaffleProducts: () => dispatch(getRaffleProducts()),
  submit : ()=> dispatch(doSentLinkVerificationEmail()),
  submitRaffle: (product) => dispatch(submitRaffle(product)),
})

export default connect(mapStateToProps, mapDispatchToProps)(RaffleSelectSneakers);


